import { biLogger } from '../biLogger';
import { locale } from '../constants';
import { selectBiData } from '../selectors';
import { BiEventLogger, StatusBannerBiData } from '../types';
import { getKbWidgetState, getRuntimeDataForBi } from '../utils';

export const logChatbotStatusBannerStatusBannerDismissed: BiEventLogger<StatusBannerBiData> = async (
  state,
  data,
) => {
  const biData = selectBiData(state);
  const { sessionId, chatbotView, contextBi } = await getRuntimeDataForBi(state);

  biLogger.chatbotStatusBannerStatusBannerDismissed({
    incident_name: data.incident_name,
    incident_severity: data.incident_severity,
    incident_state: data.incident_state,
    banner_type: data.banner_type,
    banner_name: data.banner_name,
    banner_text: data.banner_text,
    conversation_id: biData.conversationId,
    lang: locale,
    chatbot_view: chatbotView,
    session_id: sessionId,
    kb_widget_state: getKbWidgetState(state),
    main_option_name: biData.mainOptionName,
    mapping_product: contextBi?.mapping_product,
    mapping_url: contextBi?.mapping_url,
    user_experience: contextBi?.user_experience,
    user_intent: undefined,
    local_time_zone: undefined,
    chatbot_state: undefined,
  });
};
